export const validateContactDetail = (type: string, value: string): string | null => {
  if (!value?.trim()) {
    return null;
  }

  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const phoneRegex =  /^(\d{10}|\d{3}-\d{3}-\d{4}|\d+-\d{3}-\d{4})$/;
  const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

  if (type === "email" && !emailRegex.test(value)) {
    return "Please enter a valid email address";
  }

  if (type === "phone" && !phoneRegex.test(value)) {
    return "Please enter a valid phone number (e.g. 1234567890, 777-888-5555, 1-624-1128)";
  }

  if (type === "url" && !urlRegex.test(value)) {
    return "Please enter a valid link (e.g. www.example.com or https://example.com)";
  }

  return null; 
};